export default __webpack_public_path__ + "static/media/support.81139c13.png";